import React from "react";
import testSho from '../../Content/Image/Testsho.jpg'
import Ordibehesht from '../../Content/Image/Ordibehesht.jpg'
import Asanegar from '../../Content/Image/Asanegar.jpg'
import Arses from '../../Content/Image/Arses.jpg'
import sahand from '../../Content/Image/sahand.jpg'
import Mahdasht from '../../Content/Image/mahdasht.jpg'
export default function Works() {
  return (
    <div>
      <div className="main-articles ">
        <div className="col-12">
          <h2 className="title title--h1 first-title title__separate fw-9">
            نمونه کار
          </h2>
          <div className="col-12 mt-5">
            <div className="row mx-0">
              <div className="col-12 col-lg-6 mb-4">
                <div className="col-12 px-0 workBox">
                  <a href="https://testsho.com/" target="_blank">
                    <img
                      src={testSho}
                      alt="Testsho"
                      className="w-100"
                    />
                    <p className="text-center text-white text-xsmall fw-9 my-2">
                      تست‌شو
                    </p>
                  </a>
                </div>
              </div>
              <div className="col-12 col-lg-6 mb-4">
                <div className="col-12 px-0 workBox">
                  <a href="https://Ordibeheesht.ir" target="_blank">
                    <img
                      src={Ordibehesht}
                      alt="Ordibeheesht"
                      className="w-100"
                    />
                    <p className="text-center text-white text-xsmall fw-9 my-2">
                      اردیبهشت
                    </p>
                  </a>
                </div>
              </div>
              <div className="col-12 col-lg-6 mb-4">
                <div className="col-12 px-0 workBox">
                  <a href="https://Asanegar.com/" target="_blank">
                    <img
                      src={Asanegar}
                      alt="Asanegar"
                      className="w-100"
                    />
                    <p className="text-center text-white text-xsmall fw-9 my-2">
                      آسانگار
                    </p>
                  </a>
                </div>
              </div>
              <div className="col-12 col-lg-6 mb-4">
                <div className="col-12 px-0 workBox">
                  <a href="http://www.arsesproject.com/" target="_blank">
                    <img
                      src={Arses}
                      alt="Arses"
                      className="w-100"
                    />
                    <p className="text-center text-white text-xsmall fw-9 my-2">
                      نرم‌افزار مدیریت‌پروژه آرسس
                    </p>
                  </a>
                </div>
              </div>
              <div className="col-12 col-lg-6 mb-4">
                <div className="col-12 px-0 workBox">
                  <a href="http://www.sahandcrm.com/" target="_blank">
                    <img
                      src={sahand}
                      alt="sahand"
                      className="w-100"
                    />
                    <p className="text-center text-white text-xsmall fw-9 my-2">
                      نرم‌افزار مدیریت‌ مشتری سهند
                    </p>
                  </a>
                </div>
              </div>
              <div className="col-12 col-lg-6 mb-4">
                <div className="col-12 px-0 workBox">
                  <a href="http://www.mahdasht.org/" target="_blank">
                    <img
                      src={Mahdasht}
                      alt="Mahdasht"
                      className="w-100"
                    />
                    <p className="text-center text-white text-xsmall fw-9 my-2">
                      شهرداری ماهدشت
                    </p>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
